export interface MarketplaceBuyerNdaTermPreferences {
    id: number;
    dateCreated: Date;
    isSnapshot: boolean;

    nonDisclosurePeriod: NdaTerms;
    nonSolicitationDvmNamesVisible: NdaTerms;
    nonSolicitationDvmNamesBlinded: NdaTerms;
    nonSolicitationStaffNamesVisible: NdaTerms;
    nonSolicitationStaffNamesBlinded: NdaTerms;
}

export enum NdaTerms {
    NA,
    OneYear,
    TwoYears,
    ThreeYears,
}

export const NdaTermsList = [
    { id: 0, name: 'NA', tag: 'NA' },
    { id: 1, name: '1 Year', tag: 'OneYear' },
    { id: 2, name: '2 Years', tag: 'TwoYears' },
    { id: 3, name: '3 Years', tag: 'ThreeYears' },
];
